//Constants
import * as ACTIONS from './actionTypes';

//Types
import { Menu } from './types';
import { ActionGetMenuApiSuccess } from './actions';

export interface MenuState {
    items?: Menu[]
}

const defaultState: MenuState = {
    items: undefined
};

type MenuAction = ActionGetMenuApiSuccess;

function menuReducer(state: MenuState = defaultState, action: MenuAction): MenuState {
    switch (action.type) {
        case ACTIONS.GET_MENU_API_SUCCESS:
            {
                return {
                    ...state,
                    items: action.menuItems
                }
            }
    }
    return {
        ...state
    }
}

export default menuReducer;